import React, { useEffect } from 'react';
import Container from 'reactstrap/lib/Container';
import { connect } from 'react-redux';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { TrackingHandler } from 'client/tracking/handler';
import { TrackingMap } from 'client/tracking/maps/industry-center';
import { getPressLandingContentPath } from 'site-modules/editorial/utils/content-path';
import { MediaContactsModule } from 'site-modules/editorial/components/press/media-contacts-module/media-contacts-module';
import { LatestPressReleases } from 'site-modules/editorial/components/press/latest-press-releases/latest-press-releases';
import { PressReleasesArchive } from 'site-modules/editorial/components/press/press-releases-archive/press-releases-archive';

import './press.scss';

export function PressLandingUI({ content = null }) {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    TrackingHandler.useMap(TrackingMap);
  }, []);

  if (!content) {
    return null;
  }

  const mediaContactsEntry = content.child('media-contacts');
  const latestReleasesEntry = content.child('latest-releases');
  const archiveEntry = content.child('archive');

  return (
    <main id="main-content" tabIndex={-1} className="press-landing py-2">
      <Container>
        <MediaContactsModule entry={mediaContactsEntry} />
        <LatestPressReleases entry={latestReleasesEntry} />
        <PressReleasesArchive entry={archiveEntry} />
      </Container>
    </main>
  );
}

PressLandingUI.propTypes = {
  content: CmsEntities.Content,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const PressLanding = connect(mapStateToProps)(
  connectToModel(PressLandingUI, {
    content: bindToContent(() => getPressLandingContentPath()),
  })
);
